export default __webpack_public_path__ + "static/media/marauders-map-v3-05-03.858b4a74.jpg";